import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

const mobileToggle = document.querySelector('[data-mobile-toggle]');
const mobileNav = document.querySelector('[data-mobile-navigation]');
const mobileBg = document.querySelector('[data-mobile-navigation-bg]');
const mobileClose = document.querySelector('[data-mobile-navigation-close]');

let isOpen = false;

const open = () => {
    isOpen = true;

    mobileNav.classList.add('is-active');
    mobileToggle.classList.add('is-active');
    mobileToggle.setAttribute('aria-expanded', 'true');

    disableBodyScroll(mobileNav);
};

const close = () => {
    isOpen = false;

    mobileNav.classList.remove('is-active');
    mobileToggle.classList.remove('is-active');
    mobileToggle.setAttribute('aria-expanded', 'false');

    enableBodyScroll(mobileNav);
};

const toggle = () => {
    (isOpen ? close : open)();
};

const onKeyDown = event => {
    const { keyCode, which } = event;

    const key = which || keyCode;

    switch (key) {
        case 27: // Esc
            close();
            break;
        default:
        // Do nothing
    }
};

const init = () => {
    if (mobileToggle && mobileNav) {
        mobileToggle.addEventListener('click', toggle);
    }

    if (mobileBg) {
        mobileBg.addEventListener('click', close);
    }

    if (mobileClose) {
        mobileClose.addEventListener('click', close);
    }

    window.addEventListener('keydown', onKeyDown);
};

init();
